import React, { useState } from 'react';

import DraggableList from 'components/draggable_list/DraggableList';
import EditDeleteButtons from 'components/buttons/EditDeleteButtons';
import IngredientDialog from './IngredientsDialog';
import IngredientsCard from './ingredients_card/IngredientsCard';

const IngredientsList = ({
  ingredientUIModels = [],
  setIngredientUIModels,
  removeIngredient,
  editIngredient,
}) => {
  const [editedIngredient, setEditedIngredient] = useState(null);
  const isBeingEdited = !!editedIngredient;

  const openEditDialog = (editedIngredient) =>
    setEditedIngredient(editedIngredient);
  const closeEditDialog = () => setEditedIngredient(null);

  const _editIngredient = (ingredientText) => {
    editIngredient(editedIngredient, { ...editedIngredient, ingredientText });
  };

  return (
    <React.Fragment>
      <div style={{ margin: -8 }}>
        <DraggableList
          items={ingredientUIModels}
          setItems={setIngredientUIModels}
          renderItem={(ingredientUIModel, isLastItem, isDraggingOver) => {
            return (
              <IngredientsCard
                ingredientUIModel={ingredientUIModel}
                isDraggingOver={isDraggingOver}
                renderButtons={() => (
                  <EditDeleteButtons
                    message={
                      <span>
                        Click again to <b>remove</b> this ingredient
                      </span>
                    }
                    onEditButtonClick={() => openEditDialog(ingredientUIModel)}
                    onRemoveButtonClick={() =>
                      removeIngredient(ingredientUIModel)
                    }
                  ></EditDeleteButtons>
                )}
              ></IngredientsCard>
            );
          }}
        ></DraggableList>
      </div>

      <IngredientDialog
        isOpened={isBeingEdited}
        closeDialog={closeEditDialog}
        title={'Edit Ingredient'}
        ingredientAction={_editIngredient}
        actionButtonLabel="Edit"
        initialIngredient={editedIngredient}
      ></IngredientDialog>
    </React.Fragment>
  );
};

export default IngredientsList;
